import Footer from "./../../Footer";
import * as React from "react";
import {GatewayProvider} from "react-gateway";
import {useTranslation} from "react-i18next";
import {FaLock} from "react-icons/fa";
import {isCart, useUnsafeCartContext} from "../../cart/CartContextProvider/CartContextProvider";
import ShoppingCart, {TotallyEmptyCart} from "../../cart/ShoppingCart/ShoppingCart";
import Modal from "./Modal";
import styles from "./CartWrapperModal.module.scss";
import {BsArrowLeft as ArrowLeft} from "react-icons/bs";

interface ICartWrapperProps {
  isCartVisible: boolean;
  closeFunction: () => void;
}

const CartWrapperModal: React.FC<ICartWrapperProps> = (props) => {
  const context = useUnsafeCartContext();
  const {t} = useTranslation("cart");

  if (!context) {
    return null;
  }

  const Header: React.FC = () => {
    const onLogoClicked = () => {
      if (isCart(context)) {
        context.setIsIntoCheckout(false);
      }
      props.closeFunction();
    };

    return (
      <div>
        <div className={styles.wrapper}>
          <div className={`${styles.logo} svg-main-logo-both`} onClick={onLogoClicked} />
          <div className={styles.secureOrder}>
            <FaLock />
            <span>&#160;{t("Sichere Bestellung")}</span>
          </div>
        </div>
        {isCart(context) && !context.isIntoCheckout && (
          <div className={styles.backButton} onClick={props.closeFunction}>
            <ArrowLeft className={styles.arrowleftIcon} />

            <span>{t("Weiter einkaufen")}</span>
          </div>
        )}
      </div>
    );
  };

  return (
    <Modal fullScreen={true} isVisible={context.isCartVisible}>
      <div>
        <Header />
        {isCart(context) ? (
          <GatewayProvider>
            <ShoppingCart />
          </GatewayProvider>
        ) : (
          <TotallyEmptyCart />
        )}
      </div>
      <Footer />
    </Modal>
  );
};

export default CartWrapperModal;
